import { createSelector, createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { STORAGE_KEY_APP_JWT } from "../../consts";
import { type ReduxState } from "../store.redux";

const STORAGE_KEY_APP_REFRESH_TOKEN = "dxp-app-refresh-token";

export type AuthState = {
	appJwt: string | null;
	appRefreshToken: string | null;
};

const INITIAL_STATE: AuthState = {
	appJwt: typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY_APP_JWT) : null,
	appRefreshToken:
		typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY_APP_REFRESH_TOKEN) : null,
};

const authSlice = createSlice({
	name: "auth",
	initialState: INITIAL_STATE,
	reducers: {
		setAppTokens: (
			state,
			action: PayloadAction<{ accessToken: string; refreshToken: string } | null>,
		) => {
			if (action.payload) {
				state.appJwt = action.payload.accessToken;
				state.appRefreshToken = action.payload.refreshToken;
				localStorage.setItem(STORAGE_KEY_APP_JWT, action.payload.accessToken);
				localStorage.setItem(STORAGE_KEY_APP_REFRESH_TOKEN, action.payload.refreshToken);
			} else {
				state.appJwt = null;
				state.appRefreshToken = null;
				localStorage.removeItem(STORAGE_KEY_APP_JWT);
				localStorage.removeItem(STORAGE_KEY_APP_REFRESH_TOKEN);
			}
		},
		clearAppTokens: (state) => {
			state.appJwt = null;
			state.appRefreshToken = null;
			localStorage.removeItem(STORAGE_KEY_APP_JWT);
			localStorage.removeItem(STORAGE_KEY_APP_REFRESH_TOKEN);
		},
	},
});

export const { setAppTokens, clearAppTokens } = authSlice.actions;
export const AuthSliceReducer = authSlice.reducer;

const selectAuthSlice = (state: ReduxState) => state.auth;

export const selectAppJwt = createSelector(selectAuthSlice, (state) => state.appJwt);
export const selectAppRefreshToken = createSelector(
	selectAuthSlice,
	(state) => state.appRefreshToken,
);
export const selectHasAppJwt = createSelector(selectAuthSlice, (state) => !!state.appJwt);
